import React, { useEffect, useState } from "react"
import InfiniteScroll from "react-infinite-scroll-component"
import { getStoryblokApi } from "gatsby-source-storyblok"
import gsap from "gsap"
import ScrollTrigger from "gsap/ScrollTrigger"
import Grid from "../grid/grid.js"

const PoweredByZignalQuery = ({ blok, pageInfo }) => {
  const storyblokApi = getStoryblokApi()
  const [page, setPage] = useState(1)
  const [totalPages, setTotalPages] = useState(0)
  const [gridBlok, setGridBlok] = useState({
    ...blok,
    class: "powered_by_zignal_query",
    per_row: 3,
    column_gap: "0",
    row_gap: 60,
    component_horozontal_align: "left",
    grid_items: [],
  })

  useEffect(() => {
    if (typeof window == "undefined" || window.parent.location !== window.location) {
      // You are in Draft Mode or in the Visual Editor. Skip animation.
      return
    }

    if (!gridBlok.grid_items.length) {
      gsap.registerPlugin(ScrollTrigger)
      return
    }
    // Image reveal.
    ScrollTrigger.batch(".powered_by_zignal_query .gs_reveal_img", {
      onEnter: images => gsap.set(images, { stagger: 0.2, attr: { in: 1 } }),
      onLeaveBack: images => gsap.set(images, { attr: { in: 0 } }),
    })
    // Content reveal.
    ScrollTrigger.batch(".powered_by_zignal_query .gs_reveal", {
      onEnter: el => gsap.set(el, { stagger: 0.2, attr: { in: 1 } }),
      onLeaveBack: el => gsap.set(el, { attr: { in: 0 } }),
    })
  }, [gridBlok])

  const fetchMoreData = () => {
    storyblokApi
      .get("cdn/stories", {
        version: "published",
        per_page: blok.per_page,
        page: page,
        sort_by: "first_published_at:desc",
        filter_query: {
          component: { in: "powered_by_zignal" },
        },
      })
      .then(({ data, total }) => {
        if (page === 1) {
          setTotalPages(Math.ceil(total / blok.per_page))
        }

        const newPosts = data.stories.map(story => ({
          _uid: story.uuid,
          grid_content: [
            {
              ...story,
              full_slug: `/${story.full_slug}`,
              _uid: story.uuid,
              component: "post_card",
              content: story.content,
              cta_text: blok.cta_text,
              cta_style: blok.cta_style,
            },
          ],
        }))

        setGridBlok({
          ...gridBlok,
          grid_items: [...gridBlok.grid_items, ...newPosts],
        })

        setPage(page + 1)
      })
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => fetchMoreData(), [])

  return (
    <InfiniteScroll
      dataLength={gridBlok.grid_items.length}
      next={fetchMoreData}
      hasMore={page <= totalPages}
    >
      <Grid blok={gridBlok}></Grid>
    </InfiniteScroll>
  )
}

export default PoweredByZignalQuery
